jQuery(document).ready(function($) {
  // $("form.variations_form select[name=attribute_size]").before(
  //   '<div class="d-flex">'
  // );
  // $("form.variations_form select[name=attribute_size]").after("</div>");
  // $("form.variations_form select[name=attribute_size]").after(
  //   '<button class="btn-reset reset_variations" type="button">Reset</button>'
  // );

  // $('[class^="attribute-group"]').each(function() {
  //   $(this)
  //     .find("> label")
  //     .after(`<span class="current-value"></span>`);
  // });

  // $('[name^="attribute_"]').on("change", function(e) {
  //     let label = this.value
  //     if (this.type == 'radio') {
  //       label = $(this).siblings('label').text()
  //     } else {
  //         label = $(this).find('option:checked').text()
  //     }
  //   $(this)
  //     .parents('[class^="attribute-group"]')
  //     .find(".current-value")
  //     .text(label);
  // });

  /**
   * Initialize the product thumbnail carousel
   */
  $(".carousel--product-thumbnails").owlCarousel({
    nav: true,
    navText: [
      `<span class="sr-only">Previous Image</span><i class="fa fa-caret-left"></i>`,
      `<span class="sr-only">Next Image</span><i class="fa fa-caret-right"></i>`,
    ],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 3,
      },
    },
  });
});
